export default {
    firebaseConfig: {
        apiKey: "AIzaSyA28SQ6q3mkTfkOc7wLOW-C_ZFpMb6l564",
        authDomain: "geeksanon-firebase.firebaseapp.com",
        databaseURL: "https://geeksanon-firebase.firebaseio.com",
        projectId: "geeksanon-firebase",
        storageBucket: "geeksanon-firebase.appspot.com",
        messagingSenderId: "166096295908"
    }
};



// WEBPACK FOOTER //
// ./firebaseConfig.js